import { Component,Input } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'calsoft-textwithicontype',
  templateUrl: './textwithicontype.component.html',
  styleUrls: ['./textwithicontype.component.scss']
})
export class TextwithicontypeComponent {

   @Input() item: any;
    @Input() img: any;
    @Input() data: any;
    @Input() brands: any[] = [];
    public serverPath = environment.commonImageApi + '/home/';
    public bannerServerPath = environment.commonImageApi + '/commonSlider/';

    constructor(private commonService: CommonService) {
        
         }


  goToCategories(id: any) {
    if(id>0){
      this.commonService.goToCategory(1, parseInt(id));
    }

  }
  

  link(url: any) {

    this.commonService.goToLink(url)
  }

  openInNewWindow(url: string) {
    if (url) {
      const fullURL = this.prependProtocol(url);
      this.commonService.goToLink(url)
    }
  }

  prependProtocol(url: string): string {
    if (!url.includes('http://') && !url.includes('https://')) {
      return 'https://' + url;
    }
    return url;
  }

}
